import PropTypes from 'prop-types';
import styles from './DsasButton.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';

function DsasButton({ 
  label, 
  icon, // imported FontAwesome icon, e.g., 'faCamera', 'faPlus', etc.
  type = 'button',
  onClick, 
  variant = 'secondary', 
  focused=true, 
  disabled=false,
  upload = false, 
  customCss = {}, // custom CSS object
  customIcon, // custom imported SVG icon
  customIconHover, // custom imported SVG icon for hover state
  customColorClassname = '', // custom specific color class name
  customClassname = '', // custom specific class name
  // customCss = { backgroundColor: 'red' }, // example of custom css
  onChange = () => {} // callback to get file back
 }) {

  const [isHovered, setIsHovered] = useState(false);

  let spec = focused ? 'focused' : 'unfocused';
  let typeClassName = `${variant}_${spec}`

  // console.log('DsasButton rendu avec label :', label);
  // console.log('DsasButton className specifique :', typeClassName);
  // console.log('Classes appliquées au bouton :', `${styles.button} ${ styles[typeClassName] ? styles[typeClassName] : ''}`);
  // console.log('fa icon = ',  `fa-solid fa-${icon} ${styles.icon}`)

  const fileInputRef = useRef(null);

  const handleButtonClick = (event) => {
    if (upload && fileInputRef.current) {
      fileInputRef.current.click(); // ⬅️ Simule un clic sur l'input file
    } else {
      onClick && onClick(event); // ⬅️ Sinon, exécute la fonction onClick normale
    }
  };

  
  return (
    <button 
    className={`${styles.button} ${styles[variant]} ${ styles[typeClassName] ? styles[typeClassName] : ''} ${ styles[customColorClassname] ? styles[customColorClassname] : ''} ${ styles[customClassname] ? styles[customClassname] : ''}`} 
    style={customCss}
    type={type} 
    disabled={disabled} 
    onClick={handleButtonClick}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    >
      {/* Affichage de l'icône personnalisée ou de l'icône FontAwesome */}
      {customIcon || customIconHover ? (
        <span className={styles.customIcon}>
          {(isHovered && customIconHover)
            ? customIconHover({ key: 'hover' })   // Forcer une clé unique
            : customIcon?.({ key: 'default' })}
        </span>
      ) : icon ? (
        <FontAwesomeIcon icon={icon} className={styles.icon} />
      ) : null}

      {/* Affichage du texte du bouton */}
      <span className="btnText">{label}</span>
      
      {/* Input file caché pour l'upload */}
      {upload && (
        <input 
          type="file" 
          accept="image/*" 
          ref={fileInputRef} // ⬅️ Associe l'input au ref
          hidden 
          onChange={onChange} 
        />
      )}
    </button>
  );
}

DsasButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.object,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'primarysub', 'secondary', 'secondarysub', 'alternative', 'flat', 'elevator', 'danger']),
  focused: PropTypes.bool,
  disabled: PropTypes.bool,
  upload: PropTypes.bool,  // upload
  onChange: PropTypes.func, // callback to get file back
  customCss: PropTypes.object, // custom css to override default styles
  customIcon: PropTypes.func, // custom imported SVG icon
  customIconHover: PropTypes.func, // custom imported SVG icon for hover state
  customColorClassname: PropTypes.string, // custom specific color class name
  customClassname: PropTypes.string, // custom specific class name
};

export default DsasButton;